import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { Flex } from '../flex';

const style = () => ({
  padding: '16px 32px'
});

export const CardContent = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    ...props
  } = _ref;
  const {
    theme
  } = useFela();
  const styleProps = {
    theme
  };
  return /*#__PURE__*/React.createElement(Flex, _extends({
    ref: ref
  }, props, {
    extend: style(styleProps)
  }), children);
});
CardContent.displayName = 'CardContent';
CardContent.propTypes = {
  children: PropTypes.node
};